export const ROLE_TYPES = [
    'r_teacher',
    'r_student',
    'r_personnel',
    'r_guardian',
    'r_workplaceinstructor',
    'r_class',
    'r_group',
    'r_classguardian',
    'r_schoolteacher',
    'r_studentsearch',
    'r_guardiansearch',
    'r_groupguardian',
    'r_teachersearch',
    'r_schoolpersonnel',
    'r_personnelsearch',
    'r_ownteachers',
    'r_classteachers',
    'r_studentteachers',
    'r_groupteachers',
    'r_schoolworkplaceinstructors',
    'r_workplaceinstructorssearch',
    'r_schooltrainingcoordinators',
    'r_trainingcoordinatorssearch',
];
